import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";


const LoginPage = ({ setIsAuthenticated }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    // Prepare login data
    const data = { username, password };

    try {
      // Make POST request to the back-end (PHP)
      const response = await axios.post("https://training.megascale.co.in/backend/login.php", data, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      // Handle response from the PHP API
      const result = response.data;

      if (result.status === "success") {
        setIsAuthenticated();  // If login is successful
        navigate("/admin/home");  // Redirect to the admin page
      } else {
        setError(result.message);  // Show error message if login fails
      }
    } catch (error) {
      console.error("Error:", error);
      setError("Something went wrong, please try again.");
    }
  };

  return (
    <div className="flex justify-center items-center h-screen bg-gray-100">
      <form onSubmit={handleLogin} className="bg-white p-8 rounded shadow-md w-96">
      <img
            src="/Megascale2.png"
            alt="Megascale"
            className="w-36 h-auto mx-auto"
          />
        <h2 className="text-2xl text-center font-bold mb-4">
         Admin Login</h2>
        {error && <p className="text-red-500 mb-4">{error}</p>}
        <div className="mb-4">
          <label htmlFor="username" className="block text-sm font-medium mb-2">
            Username
          </label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full px-3 py-2 border rounded-lg"
            required
          />
        </div>
        <div className="mb-4">
          <label htmlFor="password" className="block text-sm font-medium mb-2">
            Password
          </label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-3 py-2 border rounded-lg"
            required
          />
        </div>
        <button
          type="submit"
          className="w-full bg-blue-500 text-white py-2 rounded-lg hover:bg-blue-600"
        >
          Login
        </button>
      </form>
    </div>
  );
};

export default LoginPage;
